import type { Catalogue } from './en.js';

/** German interface catalogue. Typed against English: a missing key will not build. */
export const de: Catalogue = {
  'common.back': 'Zurück',
  'common.cancel': 'Abbrechen',
  'common.close': 'Schließen',
  'common.copy': 'Link kopieren',
  'common.copied': 'Kopiert',
  'common.copyShort': 'Kopieren',
  'common.loading': 'Wird geladen…',
  'common.save': 'Speichern',
  'common.signOut': 'Abmelden',
  'common.settings': 'Einstellungen',
  'common.profile': 'Profil',
  'common.branding': 'Chat-Gestaltung',
  'common.search': 'Suchen',
  'common.menu': 'Menü',
  'common.retry': 'Erneut versuchen',

  'error.generic': 'Etwas ist schiefgelaufen.',
  'error.notFound': 'Nicht gefunden',
  'error.notFoundBody': 'Unter dieser Adresse gibt es nichts.',

  'login.title': 'Anmelden',
  'login.subtitle': 'Keine Passwörter. Wir senden Ihnen einen einmaligen Link per E-Mail.',
  'login.emailLabel': 'E-Mail-Adresse',
  'login.submit': 'Anmeldelink senden',
  'login.sentTitle': 'Sehen Sie in Ihr Postfach',
  'login.sentBody':
    'Falls zu dieser Adresse ein Konto besteht, ist ein Anmeldelink unterwegs. Er läuft in {minutes} Minuten ab und lässt sich einmal verwenden.',
  'login.sentNoticeTitle': 'Das Öffnen des Links meldet Sie noch nicht an',
  'login.sentNoticeBody':
    'Sie werden gebeten, auf „Weiter“ zu drücken. Das ist Absicht: So können E-Mail-Scanner und Link-Vorschauen Ihren Link nicht verbrauchen, bevor Sie ihn nutzen.',
  'login.useDifferent': 'Andere Adresse verwenden',
  'login.emailNoticeTitle': 'Ihre E-Mail-Adresse ist nicht Ende-zu-Ende-verschlüsselt',
  'login.emailNoticeBody':
    'Sie ist ein Kontodatensatz und dient der Anmeldung sowie der Benachrichtigung, wenn jemand einem Ihrer Links beitritt. Gesprächsinhalte sind davon getrennt und werden in Ihrem Browser verschlüsselt.',
  'login.failed': 'Der Anmeldelink konnte nicht gesendet werden. Versuchen Sie es gleich erneut.',
  'login.backToStart': 'Zurück zum Anfang',

  'confirm.checking': 'Anmeldelink wird geprüft…',
  'confirm.title': 'Anmeldung abschließen',
  'confirm.subtitle': 'Ein Schritt mehr, mit Absicht.',
  'confirm.as': 'Sie melden sich gleich als {email} an.',
  'confirm.explain':
    'Bisher ist nichts geschehen. Dieser Link ist weiterhin unbenutzt und bleibt es, bis Sie auf „Weiter“ drücken — deshalb kann ein Scanner, der ihn öffnet, Sie nicht anmelden.',
  'confirm.continue': 'Weiter',
  'confirm.unavailable': 'Anmeldelink nicht verfügbar',
  'confirm.expired': 'Dieser Anmeldelink ist abgelaufen. Links gelten {minutes} Minuten.',
  'confirm.used': 'Dieser Anmeldelink wurde bereits verwendet. Jeder Link funktioniert einmal.',
  'confirm.invalid': 'Dieser Anmeldelink ist ungültig.',
  'confirm.requestNew': 'Neuen Link anfordern',
  'confirm.failed': 'Die Anmeldung ist fehlgeschlagen. Fordern Sie einen neuen Link an.',

  'messenger.newConversation': 'Neuer Link',
  'messenger.newConversationHint':
    'Erstellt einen privaten Link. Senden Sie ihn an eine Person; sie gibt einen Namen ein und das Gespräch beginnt.',
  'messenger.creatingLink': 'Wird erstellt…',
  'messenger.someoneJoined': 'Jemand ist einem Ihrer Links beigetreten.',
  'messenger.searchPlaceholder': 'Suchen',
  'messenger.clearSearch': 'Suche zurücksetzen',
  'messenger.filterAll': 'Alle',
  'messenger.filterUnread': 'Ungelesen',
  'messenger.filterActive': 'Aktiv',
  'messenger.filterEnded': 'Beendet',
  'messenger.emptyTitle': 'Noch keine Gespräche',
  'messenger.emptyBody':
    'Erstellen Sie einen Link und senden Sie ihn an eine einzelne Person, um zu beginnen.',
  'messenger.noMatch': 'Zu dieser Suche gibt es nichts.',
  'messenger.loadingList': 'Gespräche werden geladen…',
  'messenger.welcomeTitle': 'Kairelo',
  'messenger.welcomeBody':
    'Senden Sie jemandem einen Link und sprechen Sie {hours} Stunden lang. Nachrichten werden in Ihrem Browser verschlüsselt, und danach bleibt nichts erhalten.',
  'messenger.encrypted': 'Ende-zu-Ende-verschlüsselt',
  'messenger.opening': 'Gespräch wird geöffnet…',
  'messenger.notOpenedYet':
    'Diese Einladung wurde noch von niemandem geöffnet. Sie wird zu einem Gespräch, sobald jemand beitritt.',
  'messenger.ended': 'Dieses Gespräch ist beendet. Es gibt kein Protokoll.',
  'messenger.suspendedTitle': 'Konto gesperrt',
  'messenger.suspendedBody':
    'Bestehende Links wurden widerrufen, und neue lassen sich nicht erstellen.',

  'row.unusedInvitation': 'Nicht genutzte Einladung',
  'row.invitationTitle': 'Einladung',
  'row.invitationWaiting': 'Wartet darauf, geöffnet zu werden',
  'row.invitationExpiresToday': 'Läuft heute ab',
  'row.invitationExpiresIn': 'Läuft in {days} Tagen ab',
  'row.visitor': 'Besucher',
  'row.conversation': 'Gespräch',
  'row.notOpened': 'Einladung noch nicht geöffnet',
  'row.ended': 'Dieses Gespräch ist beendet',
  'row.deleted': 'Gelöscht',
  'row.noKey': 'Kein Schlüssel in diesem Browser',
  'row.joined': 'Beigetreten',
  'row.joinedSayHello': 'Beigetreten — sagen Sie Hallo',
  'row.messageCount': '{count} Nachrichten',
  'row.messageCountOne': '1 Nachricht',
  'row.yesterday': 'Gestern',

  'chat.online': 'online',
  'chat.offline': 'offline',
  'chat.typing': 'schreibt…',
  'chat.connecting': 'verbindet…',
  'chat.reconnecting': 'verbindet erneut…',
  'chat.conversationEnded': 'beendet',
  'chat.back': 'Zurück zu den Gesprächen',
  'chat.about': 'Über dieses Gespräch',
  'chat.report': 'Melden',
  'chat.encryptionBanner':
    'Nachrichten werden in Ihrem Browser verschlüsselt. Dieses Gespräch endet von selbst und hinterlässt kein Protokoll.',
  'chat.emptyWithKey':
    'Noch keine Nachrichten. Alles, was Sie senden, wird zuerst hier verschlüsselt.',
  'chat.emptyNoKey':
    'Dieser Browser besitzt den Schlüssel für dieses Gespräch nicht, daher lassen sich die Nachrichten hier nicht lesen.',
  'chat.endedComposer': 'Dieses Gespräch ist beendet.',
  'chat.endNow': 'Gespräch jetzt beenden',
  'chat.endTitle': 'Dieses Gespräch jetzt beenden?',
  'chat.endBody':
    'Der Zugang endet für Sie beide sofort, und die verschlüsselte Kopie des Dienstes geht nach dem üblichen Zeitplan in die Löschung.',
  'chat.endCaveat':
    'Es lässt sich nichts zurückholen, was die andere Person bereits gesehen, gespeichert oder als Screenshot festgehalten hat. Das kann hier nichts.',
  'chat.endConfirm': 'Jetzt beenden',
  'chat.ended': 'Gespräch beendet.',
  'chat.endFailed': 'Das Gespräch konnte nicht beendet werden.',
  'chat.clearFromList': 'Aus der Liste entfernen',
  'chat.today': 'Heute',
  'chat.yesterday': 'Gestern',

  'message.unreadable': 'Verschlüsselte Nachricht, die in diesem Browser nicht gelesen werden kann',
  'message.tapToDecrypt': 'Zum Entschlüsseln tippen · {size}',
  'message.decrypting': 'Wird entschlüsselt…',
  'message.couldNotOpen': 'Konnte nicht geöffnet werden',
  'message.decryptAndDownload': 'Entschlüsseln und herunterladen',
  'message.save': '{filename} speichern',
  'message.testAdapter': 'Testadapter',
  'message.sending': 'Wird gesendet',
  'message.sent': 'Gesendet',
  'message.failed': 'Nicht gesendet',
  'message.playVoice': 'Sprachnachricht abspielen',
  'message.pauseVoice': 'Sprachnachricht pausieren',
  'message.playbackPosition': 'Wiedergabeposition',

  'composer.placeholder': 'Nachricht schreiben',
  'composer.disabled': 'Kein Schlüssel in diesem Browser',
  'composer.emoji': 'Emoji',
  'composer.attach': 'Anhängen',
  'composer.photosVideos': 'Fotos & Videos',
  'composer.document': 'Dokument',
  'composer.record': 'Sprachnachricht aufnehmen',
  'composer.stopAndSend': 'Aufnahme beenden und senden',
  'composer.cancelRecording': 'Aufnahme abbrechen',
  'composer.recording': 'Aufnahme',
  'composer.send': 'Senden',
  'composer.notConnected': 'Nicht verbunden. Die Nachricht wurde nicht gesendet.',
  'composer.fileFailed': 'Diese Datei konnte nicht gesendet werden.',
  'composer.voiceFailed': 'Die Sprachnachricht wurde nicht gesendet.',

  'invite.title': 'Einladungslink',
  'invite.subtitle': 'Einmal sichtbar. Der enthaltene Schlüssel hat den Server nie erreicht.',
  'invite.reveal': 'Zum Anzeigen klicken',
  'invite.revealLabel': 'Einladungslink anzeigen',
  'invite.copied': 'Link kopiert. Senden Sie ihn nur an eine einzige Person.',
  'invite.failed': 'Der Link konnte nicht erstellt werden.',
  'invite.whatToKnow': 'Was Sie über diesen Link wissen sollten',
  'invite.blockedTitle': 'Neue Links sind in diesem Browser blockiert',
  'invite.notCreated':
    '{detail} Es wurde kein Link erstellt, weil der Schlüssel in diesem Browser nicht aufbewahrt werden konnte und das Gespräch unlesbar wäre.',

  'join.opening': 'Einladung wird geöffnet…',
  'join.defaultBio':
    '{name} nutzt Kairelo für kurze, private Gespräche. Nachrichten werden in Ihrem Browser verschlüsselt, und dieses hier endet von selbst, ohne dass ein Protokoll bleibt.',
  'join.invitedBy': 'Sie wurden zu einem privaten Gespräch eingeladen',
  'join.title': 'Diesem Gespräch beitreten',
  'join.subtitle':
    'Wählen Sie einen Namen, unter dem Sie erscheinen. Er wird in Ihrem Browser verschlüsselt, der Dienst sieht ihn also nie.',
  'join.nameLabel': 'Ihr Anzeigename',
  'join.namePlaceholder': 'Wie soll man Sie nennen?',
  'join.nameHint':
    'Das Tippen allein bewirkt nichts. Das Gespräch beginnt erst, wenn Sie auf „Beitreten“ drücken.',
  'join.submit': 'Gespräch beitreten',
  'join.failed': 'Der Beitritt ist fehlgeschlagen. Versuchen Sie es gleich erneut.',
  'join.trustEncrypted': 'In Ihrem Browser verschlüsselt',
  'join.trustEnds': 'Endet nach {hours} Stunden',
  'join.trustNoAccount': 'Kein Konto nötig',
  'join.knowBefore': 'Was Sie vor dem Beitritt wissen sollten',
  'join.unusableTitle': 'Dieser Link lässt sich nicht verwenden',
  'join.claimed':
    'Über diesen Link ist bereits jemand beigetreten. Jede Einladung lässt genau einen Besucher zu; spätere Versuche werden auch mit dem richtigen Link abgewiesen.',
  'join.expired':
    'Diese Einladung ist abgelaufen. Nicht genutzte Einladungen gelten 30 Tage, ein Gespräch {hours} Stunden ab dem Beginn.',
  'join.invalid': 'Dieser Einladungslink ist ungültig.',
  'join.askForNew': 'Bitten Sie die Person, die ihn gesendet hat, um einen neuen Link.',
  'join.incompleteTitle': 'Dieser Link ist unvollständig',
  'join.incompleteBody':
    'Der Teil nach dem # enthält den Schlüssel, der dieses Gespräch entschlüsselt. Er erreicht den Server nie und lässt sich daher weder nachschlagen noch erneut senden.',
  'join.incompleteHint':
    'Der Link wurde vermutlich gekürzt, von einer Messenger-App abgeschnitten oder ohne sein Ende kopiert. Bitten Sie erneut um den vollständigen Link.',

  'visitor.languageNote':
    'Wird nur in diesem Browser gespeichert. Es bestimmt die Oberfläche und die Sprache, in die empfangene Nachrichten übersetzt werden.',
  'visitor.reconnecting': 'Verbindung wird wiederhergestellt…',
  'visitor.noSessionTitle': 'Dieser Browser gehört nicht zu diesem Gespräch',
  'visitor.noSessionBody':
    'Beim Beitreten entsteht ein Sitzungsnachweis, der ausschließlich im beitretenden Browser gespeichert wird. Dieser Browser besitzt keinen.',
  'visitor.noSessionRecovery':
    'Wenn Sie hier beigetreten sind und Ihre Browserdaten gelöscht haben, lässt sich das Gespräch nicht wiederherstellen — es gibt kein Konto als Rückfallebene.',
  'visitor.endedTitle': 'Dieses Gespräch ist beendet',
  'visitor.endedBody':
    'Der Zeitraum von {hours} Stunden ist vorbei. Es gibt kein Protokoll, und die verschlüsselte Kopie des Dienstes ist zur Löschung vorgemerkt.',
  'visitor.goToStart': 'Zum Anfang',

  'report.title': 'Dieses Gespräch melden',
  'report.subtitle':
    'Alles, was Sie hier schreiben, wird unverschlüsselt gesendet und gespeichert.',
  'report.warningTitle': 'Der Dienst kann Ihr Gespräch nicht lesen',
  'report.warningBody':
    'Es ist verschlüsselt, eine Meldung lässt sich also nicht mit dem Inhalt abgleichen. Was Sie unten schreiben, wird im Klartext gespeichert, zusammen mit Betriebsdaten wie Zeitstempeln und Ihrer IP-Adresse.',
  'report.reason': 'Grund',
  'report.reasonAbuse': 'Missbrauch',
  'report.reasonHarassment': 'Belästigung',
  'report.reasonIllegal': 'Rechtswidrige Inhalte',
  'report.reasonSpam': 'Spam',
  'report.reasonOther': 'Sonstiges',
  'report.details': 'Was ist geschehen',
  'report.detailsHint': 'Optional. Wird unverschlüsselt gespeichert.',
  'report.submit': 'Meldung senden',
  'report.sentTitle': 'Meldung eingegangen',
  'report.sentBody': 'Die Meldung wurde mit den Betriebsdaten des Gesprächs erfasst.',
  'report.thanks': 'Vielen Dank',
  'report.failed': 'Die Meldung konnte nicht gesendet werden. Versuchen Sie es gleich erneut.',

  'settings.title': 'Einstellungen',
  'settings.languageTitle': 'Sprache',
  'settings.languageSubtitle':
    'Für die Oberfläche und für die Übersetzung eingehender Nachrichten.',
  'settings.languageLabel': 'Ihre Sprache',
  'settings.languageHint':
    'Eingehende Nachrichten werden auf Ihrem eigenen Gerät in diese Sprache übersetzt. Nichts wird an einen Übersetzungsdienst gesendet.',
  'settings.languageSaved': 'Sprache gespeichert.',
  'settings.languageFailed': 'Die Sprache konnte nicht gespeichert werden.',
  'settings.interfaceUnavailableTitle':
    'Übersetzung auf dem Gerät ist in diesem Browser nicht verfügbar',
  'settings.interfaceUnavailableBody':
    'Ihre Sprachwahl gilt weiterhin für die Oberfläche. Nachrichten kommen in der Sprache an, in der sie geschrieben wurden, denn sie zu übersetzen hieße, sie an einen Dienst zu senden — was dieses Produkt nicht tut.',
  'settings.translationAvailableTitle': 'Übersetzung auf dem Gerät ist verfügbar',
  'settings.translationAvailableBody':
    'Eingehende Nachrichten werden in diesem Browser automatisch in Ihre Sprache übersetzt. Es wird nichts an einen Übersetzungsdienst gesendet.',
  'settings.interfaceTitle': 'Oberfläche',
  'settings.interfaceSubtitle':
    'Wie der Chat aussieht. Weitere Stile sind geplant; verfügbar ist heute nur einer.',
  'settings.interfaceLabel': 'Oberflächenstil',
  'settings.accountTitle': 'Ihr Konto',
  'settings.backToConversations': 'Zurück zu den Gesprächen',
  'settings.uiTranslated': 'Oberfläche übersetzt',
  'settings.uiEnglish': 'Oberfläche auf Englisch',
  'settings.uiEnglishNote':
    'Nachrichten werden weiterhin in diese Sprache übersetzt; die Oberfläche selbst ist noch nicht übersetzt.',

  /* ------------------------------------------------------------ landing */
  'landing.heroLine1': 'Ein Raum.',
  'landing.heroLine2': 'Ein Gespräch.',
  'landing.heroLine3': 'Nach 24 Stunden vorbei.',
  'landing.heroBody':
    'Teilen Sie einen Link. Die andere Person gibt einen Namen ein und tritt bei. Sie unterhalten sich einen Tag, und dann ist es vorbei — kein Protokoll, kein Archiv, nichts zu löschen.',
  'landing.signIn': 'Mit E-Mail anmelden',
  'landing.noAccount': 'Kein Konto. Kein Download.',
  'landing.ringLabel': 'und es ist vorbei',

  'landing.howTitle': 'So funktioniert es',
  'landing.step1Title': 'Link teilen',
  'landing.step1Body': 'Sie erstellen einen Link und teilen ihn mit einer Person.',
  'landing.step2Title': 'Sie gibt einen Namen ein',
  'landing.step2Body': 'Kein Konto, kein Download. Ein Anzeigename genügt.',
  'landing.step3Title': '24 Stunden chatten',
  'landing.step3Body': 'Danach ist alles weg.',

  'landing.getTitle': 'Was Sie bekommen',
  'landing.feature1Title': 'Einen privaten Link teilen',
  'landing.feature1Body':
    'Ihr Browser erzeugt den Schlüssel und legt ihn in das Fragment des Links — den Teil, den Browser nie an einen Server senden.',
  'landing.feature2Title': 'Namen eingeben und beitreten',
  'landing.feature2Body':
    'Keine Registrierung, kein Konto, keine App. Die andere Person tippt einen Anzeigenamen ein und legt los.',
  'landing.feature3Title': '24 Stunden, dann ist es vorbei',
  'landing.feature3Body':
    'Der Zugang endet, es gibt kein Protokoll und kein Archiv, und die verschlüsselte Kopie wird gelöscht.',
  'landing.feature4Title': 'Ende-zu-Ende-verschlüsselt',
  'landing.feature4Body':
    'Nachrichten, Fotos, Videos, Dateien und Sprachnachrichten werden in Ihrem Browser verschlüsselt, bevor sie gesendet werden.',
  'landing.feature5Title': 'Wir können es nicht lesen',
  'landing.feature5Body':
    'Im normalen Betrieb leitet der Dienst Geheimtext weiter und speichert ihn und erhält nie den Schlüssel.',

  'landing.carriesTitle': 'Was ein Gespräch enthalten kann',
  'landing.carriesMessages': 'Nachrichten',
  'landing.carriesPhotos': 'Fotos',
  'landing.carriesVideos': 'Videos',
  'landing.carriesFiles': 'Dateien',
  'landing.carriesVoice': 'Sprachnachrichten',

  'landing.notTitle': 'Was dies nicht ist',
  'landing.notBody1':
    'Es ist nicht anonym: Der Dienst sieht weiterhin IP-Adressen, Zeitstempel und Browserinformationen. Er ist nicht unabhängig geprüft. Es wird keine Eignung für regulierte berufliche Nutzung behauptet.',
  'landing.notBody2':
    'Ein Gespräch lässt sich nur in dem Browserprofil lesen, das es erstellt hat oder ihm beigetreten ist. Geht dieses Profil verloren, ist das Gespräch unlesbar — für alle, auch für uns.',
  'landing.languageLabel': 'Sprache',

  /* -------------------------------------------------------- disclosures */
  'disclosure.copyingTitle': 'Alles auf dem Bildschirm kann kopiert werden',
  'disclosure.copyingBody':
    'Beide Seiten können dieses Gespräch abfotografieren, aufzeichnen oder als Screenshot festhalten. Verschlüsselung hindert den Dienst am Mitlesen; sie hindert Ihr Gegenüber nicht daran, eine Kopie zu behalten.',
  'disclosure.bearerTitle': 'Behandeln Sie den Link wie ein Geheimnis',
  'disclosure.bearerBody':
    'Solange niemand beigetreten ist, kann jeder, der diesen Link hat, zuerst beitreten. Ihn per E-Mail oder Messenger zu senden oder ihn in der Zwischenablage, im Verlauf oder in einem Screenshot zu hinterlassen, kann ihn außerhalb des Dienstes offenlegen. Senden Sie ihn an eine Person und nur an diese.',
  'disclosure.deviceKeyTitle': 'Nur dieser Browser kann dieses Gespräch lesen',
  'disclosure.deviceKeyBody':
    'Der Schlüssel wird hier erzeugt und bleibt hier. Eine Anmeldung auf einem anderen Gerät gibt Ihnen keinen Zugang, und der E-Mail-Hinweis anderswo ebenso wenig. Den Speicher dieses Browsers zu leeren, privat zu surfen oder dieses Gerät zu verlieren macht das Gespräch dauerhaft unlesbar. Eine Wiederherstellung gibt es nicht.',
  'disclosure.scopeTitle': 'Was verschlüsselt ist und was nicht',
  'disclosure.scopeBody1':
    'Nachrichten, Fotos, Videos, Dateien, Sprachnachrichten und der Anzeigename des Besuchers werden im Browser verschlüsselt. Das Profil des Inhabers, die Konto-E-Mail-Adresse und betriebliche Aufzeichnungen wie Zeitstempel und IP-Adressen sind es nicht und werden auch nicht als Ende-zu-Ende-verschlüsselt bezeichnet.',
  'disclosure.scopeBody2':
    'Da der Verschlüsselungscode als Webseite ausgeliefert wird, könnte eine kompromittierte Installation dieses Dienstes veränderten Code ausliefern. Das ist eine Grenze browserbasierter Verschlüsselung und lässt sich durch Design allein nicht beseitigen. Die Kryptografie hier ist nicht unabhängig geprüft.',
  'disclosure.notAnonymousTitle': 'Ohne Registrierung heißt nicht anonym',
  'disclosure.notAnonymousBody':
    'Sie brauchen kein Konto und Ihr Anzeigename ist verschlüsselt. Der Dienst sieht weiterhin betriebliche Daten wie Ihre IP-Adresse, Zeitstempel und Browserinformationen, die er für Ratenbegrenzung und Missbrauchsabwehr nutzt.',
  'disclosure.temporaryTitle': 'Dieses Gespräch endet von selbst',
  'disclosure.temporaryBody':
    'Es bleibt {hours} Stunden nach dem Start offen. Danach kann sich keine Seite mehr verbinden, es gibt kein Protokoll, und der Dienst löscht die verschlüsselte Kopie, die er hält. Backups laufen separat nach eigenem Zeitplan ab.',
};
